export default {
    excess: 'Povećana odgovornost',
    security: 'Depozit',
    fuel_policy: 'Smjernice za gorivo',
    like_for_like: 'Lajk za lajk',
    full_to_full: 'Sipati gorivo u skladu sa potrošnjom',
    mileage: 'Milje: {mileage} besplatnih milja po iznajmljivanju',
    unlimited_mileage: 'Neograničene milje',
    non_refundable: 'Refundacije nisu moguće',
    free_cancellation_until: 'Besplatno otkazivanje do {date}',
    cancellation_with_terms: 'Otkazivanje {0} u skladu sa ',
    t_c_text: 'Odredbe i uslovi',
    two_free_extras: 'Dva besplatna opciona dodatka po preuzimanju',
    glass_tyres_covered: 'Staklo i gume su obuhvaćeni'
}
